import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Slider from 'react-slick';
import ArrowButton from './ArrowButton';
import Quote from './Quote';
import Image from '../components/Image';
import styled from 'styled-components';

const StyledSliderWrapper = styled.div`
  .slick-dots>li {
    width: auto;
    height: initial;
  }
  .slick-dots>li.slick-active>div {
    background-color: #f00;
  }
`

const styles = theme => ({
    dot: {
        backgroundColor: '#ccc',
        width: 30,
        height: 6,
        color: 'transparent',
        fontSize: 0,
        borderRadius: 8,
        [theme.breakpoints.down('xs')]: {
            width: 20,
            margin: 2
        },
        '&:hover': {
            backgroundColor: '#f00'
        }
    },
    quoteMark: {
        textAlign: 'center',
        margin: '2rem auto',
    }
});

export const Dot = classes => i => (
    <div className={classes.dot}>{i + 1}</div>
)
  
class QuoteRotator extends React.Component {
    render() {
        const { classes, quotes } = this.props;
    
        return (
            <StyledSliderWrapper>
                <div className={classes.quoteMark}>
                    <Image src='/icons/left_quote.svg'/>
                </div>
                <Slider 
                    autoplay={true}
                    customPaging={Dot(classes)} 
                    dots={true} 
                    nextArrow={<ArrowButton direction='right'/>} 
                    prevArrow={<ArrowButton />}
                >
                {quotes.map((props, i) => <Quote key={i} {...props}/>)}
                </Slider>
            </StyledSliderWrapper>
        );
    }
}

QuoteRotator.propTypes = {
    classes: PropTypes.object.isRequired,
    quotes: PropTypes.array.isRequired
};

export default withStyles(styles)(QuoteRotator);
